import * as Sentry from "@sentry/react";
import * as React from "react";
import { useRouteError } from "react-router";

import { useTranslation } from "@punto/frontend-shared/i18n/i18next";

export function ErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError() as Error;

  React.useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
    console.error(error);
  }, [error]);

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-3 bg-muted">
      <div className="text-lg font-bold">{t("ErrorBoundary.title")}</div>
      <div className="text-sm">{t("ErrorBoundary.message")}</div>
    </div>
  );
}
